import type { CollapseProps } from "antd";
import Info from "./Info";
import CDNFileDetail from "./CDNFileDetail";

export const CDNFileContentConstants = {
	INFO: "Genel Bilgiler",
	CDN_FILE_DETAIL: "Dosya Detayları"
};

export const CDNFileItems: CollapseProps["items"] = [
	{
		key: "1",
		label: CDNFileContentConstants.INFO,
		children: <Info />,
	},
	{
		key: "2",
		label: CDNFileContentConstants.CDN_FILE_DETAIL,
		children: <CDNFileDetail />,
	}
];
